import React from "react";
import HeaderSection from "../../../components/headerSection";
import ImageTextCard from "../../../components/imageTextCard";
import Footer from "../home/footer";
import KeyInsights from "./keyInsights";
function Community() {
  const obj = [
    {
      title: "Discussion Forums:",
      description:
        "Engage in conversations on industry trends, job search strategies, and skill development",
    },
    {
      title: "Groups & Events:",
      description:
        " Join interest-based groups and participate in webinars, workshops, and networking events",
    },
    {
      title: "Peer Support",
      description:
        "Exchange insights, offer encouragement, and celebrate achievements with fellow members.",
    },
    {
      title: "Creativity and Innovation",
      description:
        "Creativity and innovation foster new ideas and solutions, enhancing problem-solving and keeping organizations competitive in a changing landscape.",
    },
    {
      title: "Resource Sharing:",
      description:
        "Access and contribute to a wealth of collective knowledge, including articles, tools, and tips",
    },
  ];
  const growthObj = [
    {
      title: "Introduce Yourself:",
      description:
        "Start by posting a brief introduction in the welcome thread.",
    },
    {
      title: "Ask Questions:",
      description:
        "Get matched with an expert who can help you interpret your results and plan your next steps.",
    },
    {
      title: "Share Your Knowledge:",
      description:
        "With your mentor's support, start working toward a future-proof and fulfilling career.",
    },
  ];
  return (
    <div>
      <HeaderSection
        title="Community"
        description="Join a Community Committed to Future-Proofing Careers in the Age of AI"
      />
      <ImageTextCard
        image="/group-pic.png"
        position="left"
        imageClass="w-[640px] h-auto"
        label="Join a Supportive Professional Network"
        subTitle="Our Community is a vibrant, collaborative space where you can connect with peers, share experiences, and grow together. Whether you're exploring new career paths, seeking advice, or simply looking to network, our community offers the support you need"
        buttonText="Join the Community"
      />
      <ImageTextCard
        image="/explore-group.png"
        imageClass="w-[620px] h-auto"
        label="Explore Features Designed for Collaboration and Support"
        obj={obj}
        pointIcon="/pink-right-arrow.png"
        pointIconClass="w-[17px] h-[13px] mt-2"
      />
      <KeyInsights />
      <ImageTextCard
        image="/growth-group-image.png"
        imageClass="w-[620px] h-auto"
        label="Explore Features Designed for Collaboration and Support"
        obj={growthObj}
        pointIcon="/light-pink-arrow-right.png"
        pointIconClass="w-[24px] h-[24px] mt-1"
      />
      <Footer />
    </div>
  );
}

export default Community;
